import { useState, useRef, useEffect } from "react";
import Button from "@shared/v2/Button";
import { PlaySolidV6, PauseSolidV6 } from "@shared/v2/Icomoon";

const PlayMessage = ({}) => {
  const [isPlaying, setIsPlaying] = useState(false); // Track play/pause state
  const audioRef = useRef(new Audio("https://dialer.staging.brivity.com/audio/start2.mp3"));

  useEffect(() => {
    const audio = audioRef.current;

    // Handle audio ending to reset to play icon
    const handleAudioEnd = () => setIsPlaying(false);
    audio.addEventListener("ended", handleAudioEnd);

    // Clean up event listener when component unmounts
    return () => audio.removeEventListener("ended", handleAudioEnd);
  }, []);

  const togglePlayPause = () => {
    const audio = audioRef.current;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }

    setIsPlaying(!isPlaying);
  };

  return (
    <div>
      <Button size="small" schema="tertiary" onClick={togglePlayPause}>
        {isPlaying ? <PauseSolidV6 size="s" /> : <PlaySolidV6 size="s" />}
        <span className="tw-pl-[4px]"> message</span>
      </Button>
    </div>
  );
};

export default PlayMessage;
